import { render, staticRenderFns } from "./source_branch_removal_status.vue?vue&type=template&id=4828401a"
import script from "./source_branch_removal_status.vue?vue&type=script&lang=js"
export * from "./source_branch_removal_status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports